<div class="documents-page-container">
  <div class="documents-page-title">
    <div class="documents-page-title-title">
      <img src="https://s3.ru1.storage.beget.cloud/b46325dbaad6-ilove/voucher-templates/images/logo-oval.png" alt="logo">
      <span class="title-text">DOCUMENTS</span>
    </div>
    <div class="mobile-menu-toggle" (click)="toggleMobileMenu()" *ngIf="isTab">
      <app-icon [icon]="Icons.hamburger" [invert]="true"/>
    </div>
    <div class="documents-controls" [class.mobile-open]="mobileMenuOpen">
      <div class="mobile-menu-close" (click)="toggleMobileMenu()" *ngIf="isTab">
        <app-icon [icon]="Icons.thinClose" />
      </div>
      <div class="controls-group">
        <div class="documents-search">
          <div class="documents-search-icon-first">
            <app-icon
              [icon]="Icons.magnifier"
              (click)="searching()"
            />
          </div>
          <input placeholder="Search..." [(ngModel)]="search" (keyup.enter)="searching()">
          <div class="documents-search-icon">
            <app-icon
              *ngIf="search.length > 2"
              [icon]="Icons.thinClose"
              (click)="clearSearch()"
            />
          </div>
        </div>
        <div class="buttons-group">
          <div class="documents-button" (click)="openItem()">ADD NEW</div>
          <div class="documents-button"
               *ngIf="tokenStorageService.hasRole('ADMIN')"
               (click)="navigateAdmin()">
            Admin
          </div>
          <div class="documents-button logout-btn"
               (click)="loginService.logout()"
               (mouseenter)="mouseLogout = true"
               (mouseleave)="mouseLogout = false">
            <span class="btn-text">Logout</span>
            <app-icon style="margin-left: 0.2rem;" [icon]="Icons.logout" [invert]="mouseLogout"/>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="table-container">
    <app-sortable-table
      [headers]="header"
      [data]="pagination.content ?? []"
      [currentSort]="currentSort"
      [currentSortHeader]="currentSortHeader"
      [getClearSorting]="getClearSorting"
      (openItemEmit)="openItem($event)"
      (sortEmit)="sorting($event)"
      (currentSortEmit)="setCurrentSort($event)"
      (currentSortHeaderEmit)="setCurrentSortHeader($event)"
    />
  </div>
  <div class="document-page-pagination">
    <app-pagination [pagination]="pagination" (emitPagination)="setPagination($event)"/>
  </div>
</div>
<div class="loading-container" *ngIf="loading">
  <app-loading/>
</div>
